"use client";

import { createStore } from "zustand/vanilla";

export type AuthFormStatus = "idle" | "loading" | "sent" | "success" | "error";
export type AccountRole = "user" | "business" | "admin";

type LoginFormState = {
  email: string;
  password: string;
  status: AuthFormStatus;
  message: string;
  accountRole: AccountRole;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  setStatus: (status: AuthFormStatus) => void;
  setMessage: (message: string) => void;
  setAccountRole: (accountRole: AccountRole) => void;
};

export function createLoginFormStore(accountRole: AccountRole, configurationError = false) {
  return createStore<LoginFormState>((set) => ({
    email: "",
    password: "",
    status: configurationError ? "error" : "idle",
    message: configurationError
      ? "Supabase is not configured yet. Fill `.env.local` and restart the dev server."
      : "",
    accountRole,
    setEmail: (email) => set({ email }),
    setPassword: (password) => set({ password }),
    setStatus: (status) => set({ status }),
    setMessage: (message) => set({ message }),
    setAccountRole: (nextRole) => set({ accountRole: nextRole })
  }));
}

type SignupFormState = LoginFormState & {
  fullName: string;
  confirmPassword: string;
  setFullName: (fullName: string) => void;
  setConfirmPassword: (confirmPassword: string) => void;
};

export function createSignupFormStore(accountRole: AccountRole) {
  return createStore<SignupFormState>((set) => ({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
    status: "idle",
    message: "",
    accountRole,
    setFullName: (fullName) => set({ fullName }),
    setEmail: (email) => set({ email }),
    setPassword: (password) => set({ password }),
    setConfirmPassword: (confirmPassword) => set({ confirmPassword }),
    setStatus: (status) => set({ status }),
    setMessage: (message) => set({ message }),
    setAccountRole: (nextRole) => set({ accountRole: nextRole })
  }));
}

export function createGoogleAuthPopupStore() {
  return createStore<{
    isOpen: boolean;
    mounted: boolean;
    setIsOpen: (isOpen: boolean) => void;
    setMounted: (mounted: boolean) => void;
  }>((set) => ({
    isOpen: false,
    mounted: false,
    setIsOpen: (isOpen) => set({ isOpen }),
    setMounted: (mounted) => set({ mounted })
  }));
}

export function createGoogleSignInButtonStore() {
  return createStore<{
    isLoading: boolean;
    error: string | null;
    setIsLoading: (isLoading: boolean) => void;
    setError: (error: string | null) => void;
  }>((set) => ({
    isLoading: false,
    error: null,
    setIsLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error })
  }));
}
